export const conicSectionsData = {
  title: "Analytical Geometry (Conic Sections)",
  skills: [
    {
      id: "parabolas-ellipses",
      title: "Parabolas & Ellipses",
      description: "Derive and analyze equations for parabolas and ellipses based on foci and directrices. Graph and identify key features including vertices, foci, axes, and directrices.",
      questions: [
        {
          id: 1,
          question: "Find the equation of a parabola with focus at (0, 3) and directrix y = -3.",
          options: [
            "x² = 12y",
            "x² = 6y",
            "y² = 12x",
            "x² = 3y"
          ],
          correctAnswer: 0,
          solution: "Step 1: The vertex is midway between focus and directrix: (0, 0).\n\nStep 2: Distance from vertex to focus: p = 3.\n\nStep 3: Since the focus is above the vertex, the parabola opens upward.\n\nStep 4: Standard form: x² = 4py\n\nStep 5: Substitute p = 3: x² = 4(3)y = 12y\n\nAnswer: x² = 12y"
        },
        {
          id: 2,
          question: "Find the vertices of the ellipse: (x²/25) + (y²/9) = 1",
          options: [
            "(±5, 0)",
            "(0, ±3)",
            "(±5, 0) and (0, ±3)",
            "(±3, 0) and (0, ±5)"
          ],
          correctAnswer: 0,
          solution: "Step 1: Identify a² and b² from the equation.\na² = 25, so a = 5\nb² = 9, so b = 3\n\nStep 2: Since a² > b², the major axis is horizontal.\n\nStep 3: Vertices are at (±a, 0) = (±5, 0)\n\nStep 4: Co-vertices are at (0, ±b) = (0, ±3)\n\nStep 5: The question asks for vertices (major axis endpoints).\n\nAnswer: (±5, 0)"
        },
        {
          id: 3,
          question: "A parabola has vertex at (2, -1) and focus at (2, 2). Find its equation.",
          options: [
            "(x - 2)² = 12(y + 1)",
            "(x - 2)² = 6(y + 1)",
            "(y + 1)² = 12(x - 2)",
            "(x + 2)² = 12(y - 1)"
          ],
          correctAnswer: 0,
          solution: "Step 1: Vertex (h, k) = (2, -1), Focus (2, 2)\n\nStep 2: Distance from vertex to focus: p = 2 - (-1) = 3\n\nStep 3: Since x-coordinates are the same, the parabola opens vertically.\n\nStep 4: Since focus is above vertex, it opens upward.\n\nStep 5: Standard form: (x - h)² = 4p(y - k)\n\nStep 6: Substitute: (x - 2)² = 4(3)(y + 1) = 12(y + 1)\n\nAnswer: (x - 2)² = 12(y + 1)"
        },
        {
          id: 4,
          question: "Find the foci of the ellipse: (x²/16) + (y²/25) = 1",
          options: [
            "(0, ±3)",
            "(±3, 0)",
            "(0, ±4)",
            "(±4, 0)"
          ],
          correctAnswer: 0,
          solution: "Step 1: Identify a² and b².\na² = 25, b² = 16\n\nStep 2: Since a² > b², the major axis is vertical (a² is under y²).\na = 5, b = 4\n\nStep 3: Calculate c using c² = a² - b²\nc² = 25 - 16 = 9\nc = 3\n\nStep 4: Since the major axis is vertical, foci are at (0, ±c).\n\nAnswer: (0, ±3)"
        },
        {
          id: 5,
          question: "Write the equation of an ellipse with center (0, 0), vertices at (±6, 0), and co-vertices at (0, ±4).",
          options: [
            "(x²/36) + (y²/16) = 1",
            "(x²/16) + (y²/36) = 1",
            "(x²/6) + (y²/4) = 1",
            "x²/4 + y²/6 = 1"
          ],
          correctAnswer: 0,
          solution: "Step 1: Vertices at (±6, 0) means a = 6, and the major axis is horizontal.\n\nStep 2: Co-vertices at (0, ±4) means b = 4.\n\nStep 3: Standard form with horizontal major axis: (x²/a²) + (y²/b²) = 1\n\nStep 4: Substitute a = 6 and b = 4:\n(x²/36) + (y²/16) = 1\n\nAnswer: (x²/36) + (y²/16) = 1"
        },
        {
          id: 6,
          question: "A parabola has equation y² = 8x. Find the coordinates of its focus.",
          options: [
            "(2, 0)",
            "(0, 2)",
            "(4, 0)",
            "(0, 4)"
          ],
          correctAnswer: 0,
          solution: "Step 1: Compare with standard form y² = 4px\n\nStep 2: We have 4p = 8, so p = 2\n\nStep 3: The parabola opens to the right (positive x-direction).\n\nStep 4: Vertex is at origin (0, 0).\n\nStep 5: Focus is at (p, 0) = (2, 0)\n\nAnswer: (2, 0)"
        },
        {
          id: 7,
          question: "Find the length of the major axis of the ellipse: 9x² + 16y² = 144",
          options: [
            "8",
            "6",
            "4",
            "12"
          ],
          correctAnswer: 0,
          solution: "Step 1: Convert to standard form by dividing by 144:\n(x²/16) + (y²/9) = 1\n\nStep 2: Identify a² and b²:\na² = 16, so a = 4\nb² = 9, so b = 3\n\nStep 3: Since a² > b², the major axis is horizontal with length 2a.\n\nStep 4: Length of major axis = 2a = 2(4) = 8\n\nAnswer: 8"
        },
        {
          id: 8,
          question: "An ellipse has foci at (±5, 0) and vertices at (±13, 0). Find b².",
          options: [
            "144",
            "169",
            "25",
            "194"
          ],
          correctAnswer: 0,
          solution: "Step 1: From vertices at (±13, 0), we have a = 13.\n\nStep 2: From foci at (±5, 0), we have c = 5.\n\nStep 3: Use the relationship c² = a² - b²\n\nStep 4: Solve for b²:\nb² = a² - c² = 169 - 25 = 144\n\nAnswer: 144"
        },
        {
          id: 9,
          question: "Find the directrix of the parabola: (y - 3)² = -16(x + 2)",
          options: [
            "x = 2",
            "x = -6",
            "y = 7",
            "x = -2"
          ],
          correctAnswer: 0,
          solution: "Step 1: Compare with standard form (y - k)² = 4p(x - h)\n\nStep 2: We have 4p = -16, so p = -4\n\nStep 3: Vertex (h, k) = (-2, 3)\n\nStep 4: Since p is negative, the parabola opens to the left.\n\nStep 5: Directrix is vertical line: x = h - p = -2 - (-4) = 2\n\nAnswer: x = 2"
        },
        {
          id: 10,
          question: "An ellipse has equation (x²/100) + (y²/64) = 1. Find the eccentricity.",
          options: [
            "0.6",
            "0.8",
            "0.36",
            "0.64"
          ],
          correctAnswer: 0,
          solution: "Step 1: Identify a² and b²:\na² = 100, so a = 10\nb² = 64, so b = 8\n\nStep 2: Calculate c using c² = a² - b²:\nc² = 100 - 64 = 36\nc = 6\n\nStep 3: Eccentricity e = c/a\n\nStep 4: e = 6/10 = 0.6\n\nAnswer: 0.6"
        }
      ]
    },
    {
      id: "hyperbolas",
      title: "Hyperbolas",
      description: "Derive and analyze equations for hyperbolas based on foci and asymptotes. Graph hyperbolas and identify key features including vertices, foci, asymptotes, and transverse/conjugate axes.",
      questions: [
        {
          id: 11,
          question: "Find the vertices of the hyperbola: (x²/16) - (y²/9) = 1",
          options: [
            "(±4, 0)",
            "(0, ±3)",
            "(±3, 0)",
            "(0, ±4)"
          ],
          correctAnswer: 0,
          solution: "Step 1: This is a horizontal hyperbola (x² term is positive).\n\nStep 2: Standard form: (x²/a²) - (y²/b²) = 1\n\nStep 3: Identify a² = 16, so a = 4\n\nStep 4: For horizontal hyperbola, vertices are at (±a, 0)\n\nStep 5: Vertices = (±4, 0)\n\nAnswer: (±4, 0)"
        },
        {
          id: 12,
          question: "Find the foci of the hyperbola: (y²/25) - (x²/144) = 1",
          options: [
            "(0, ±13)",
            "(±13, 0)",
            "(0, ±5)",
            "(0, ±12)"
          ],
          correctAnswer: 0,
          solution: "Step 1: This is a vertical hyperbola (y² term is positive).\n\nStep 2: Identify a² = 25 and b² = 144\na = 5, b = 12\n\nStep 3: Calculate c using c² = a² + b² (note: plus for hyperbolas)\nc² = 25 + 144 = 169\nc = 13\n\nStep 4: For vertical hyperbola, foci are at (0, ±c)\n\nAnswer: (0, ±13)"
        },
        {
          id: 13,
          question: "Find the equations of the asymptotes for: (x²/9) - (y²/16) = 1",
          options: [
            "y = ±(4/3)x",
            "y = ±(3/4)x",
            "y = ±(9/16)x",
            "y = ±(16/9)x"
          ],
          correctAnswer: 0,
          solution: "Step 1: This is a horizontal hyperbola.\n\nStep 2: Identify a² = 9 and b² = 16\na = 3, b = 4\n\nStep 3: For horizontal hyperbola, asymptotes are: y = ±(b/a)x\n\nStep 4: Substitute: y = ±(4/3)x\n\nAnswer: y = ±(4/3)x"
        },
        {
          id: 14,
          question: "Write the equation of a hyperbola with vertices at (0, ±7) and foci at (0, ±25).",
          options: [
            "(y²/49) - (x²/576) = 1",
            "(x²/49) - (y²/576) = 1",
            "(y²/576) - (x²/49) = 1",
            "(y²/25) - (x²/49) = 1"
          ],
          correctAnswer: 0,
          solution: "Step 1: Vertices at (0, ±7) means a = 7 and it's a vertical hyperbola.\n\nStep 2: Foci at (0, ±25) means c = 25.\n\nStep 3: Use c² = a² + b² to find b²:\n625 = 49 + b²\nb² = 576\n\nStep 4: Standard form for vertical hyperbola: (y²/a²) - (x²/b²) = 1\n\nStep 5: Substitute: (y²/49) - (x²/576) = 1\n\nAnswer: (y²/49) - (x²/576) = 1"
        },
        {
          id: 15,
          question: "Find the center of the hyperbola: ((x-3)²/25) - ((y+2)²/16) = 1",
          options: [
            "(3, -2)",
            "(-3, 2)",
            "(5, 4)",
            "(25, 16)"
          ],
          correctAnswer: 0,
          solution: "Step 1: Standard form: ((x-h)²/a²) - ((y-k)²/b²) = 1\n\nStep 2: Center is at (h, k)\n\nStep 3: From the equation: h = 3, k = -2\n\nStep 4: Center = (3, -2)\n\nAnswer: (3, -2)"
        },
        {
          id: 16,
          question: "A hyperbola has equation (x²/36) - (y²/64) = 1. Find the length of the transverse axis.",
          options: [
            "12",
            "6",
            "16",
            "8"
          ],
          correctAnswer: 0,
          solution: "Step 1: This is a horizontal hyperbola.\n\nStep 2: Identify a² = 36, so a = 6\n\nStep 3: The transverse axis connects the two vertices.\n\nStep 4: Length of transverse axis = 2a = 2(6) = 12\n\nAnswer: 12"
        },
        {
          id: 17,
          question: "Find the eccentricity of the hyperbola: (x²/9) - (y²/16) = 1",
          options: [
            "5/3",
            "4/3",
            "3/5",
            "16/9"
          ],
          correctAnswer: 0,
          solution: "Step 1: Identify a² = 9 and b² = 16\na = 3, b = 4\n\nStep 2: Calculate c using c² = a² + b²:\nc² = 9 + 16 = 25\nc = 5\n\nStep 3: Eccentricity e = c/a\n\nStep 4: e = 5/3\n\nAnswer: 5/3"
        },
        {
          id: 18,
          question: "Which equation represents a vertical hyperbola?",
          options: [
            "(y²/25) - (x²/9) = 1",
            "(x²/25) - (y²/9) = 1",
            "x² - y² = 1",
            "(x²/9) + (y²/25) = 1"
          ],
          correctAnswer: 0,
          solution: "Step 1: A vertical hyperbola has the y² term positive.\n\nStep 2: Standard form: (y²/a²) - (x²/b²) = 1\n\nStep 3: Check each option:\nA: (y²/25) - (x²/9) = 1 ✓ (y² is positive)\nB: (x²/25) - (y²/9) = 1 (x² is positive - horizontal)\nC: x² - y² = 1 (x² is positive - horizontal)\nD: (x²/9) + (y²/25) = 1 (ellipse, not hyperbola)\n\nAnswer: (y²/25) - (x²/9) = 1"
        },
        {
          id: 19,
          question: "A hyperbola has vertices at (±5, 0) and asymptotes y = ±(3/5)x. Find b.",
          options: [
            "3",
            "5",
            "15",
            "25"
          ],
          correctAnswer: 0,
          solution: "Step 1: Vertices at (±5, 0) means a = 5 and it's horizontal.\n\nStep 2: For horizontal hyperbola, asymptotes are y = ±(b/a)x\n\nStep 3: Given asymptotes: y = ±(3/5)x\n\nStep 4: Therefore: b/a = 3/5\n\nStep 5: Solve for b: b = (3/5) × 5 = 3\n\nAnswer: 3"
        },
        {
          id: 20,
          question: "Convert to standard form: 4x² - 9y² = 36",
          options: [
            "(x²/9) - (y²/4) = 1",
            "(x²/4) - (y²/9) = 1",
            "(x²/36) - (y²/36) = 1",
            "4(x²/9) - 9(y²/4) = 1"
          ],
          correctAnswer: 0,
          solution: "Step 1: Divide both sides by 36:\n(4x²/36) - (9y²/36) = 1\n\nStep 2: Simplify:\n(x²/9) - (y²/4) = 1\n\nStep 3: This is now in standard form.\n\nAnswer: (x²/9) - (y²/4) = 1"
        }
      ]
    },
    {
      id: "conic-applications",
      title: "Conic Sections Applications & Analysis",
      description: "Apply conic section properties to solve real-world problems. Identify conic types from general equations, complete the square to convert to standard form, and analyze geometric properties.",
      questions: [
        {
          id: 21,
          question: "Identify the conic section: x² + y² - 6x + 4y - 12 = 0",
          options: [
            "Circle",
            "Ellipse",
            "Parabola",
            "Hyperbola"
          ],
          correctAnswer: 0,
          solution: "Step 1: Check the coefficients of x² and y².\n\nStep 2: Both x² and y² have coefficient 1 (equal and same sign).\n\nStep 3: When A = C in Ax² + Cy² + ... = 0, it's a circle.\n\nStep 4: Complete the square to verify:\n(x² - 6x + 9) + (y² + 4y + 4) = 12 + 9 + 4\n(x - 3)² + (y + 2)² = 25\n\nStep 5: This is the equation of a circle with center (3, -2) and radius 5.\n\nAnswer: Circle"
        },
        {
          id: 22,
          question: "Identify the conic section: 4x² + 9y² = 36",
          options: [
            "Ellipse",
            "Circle",
            "Parabola",
            "Hyperbola"
          ],
          correctAnswer: 0,
          solution: "Step 1: Convert to standard form by dividing by 36:\n(x²/9) + (y²/4) = 1\n\nStep 2: Both terms are positive with addition.\n\nStep 3: Coefficients are different (9 ≠ 4), so it's not a circle.\n\nStep 4: This is an ellipse with a² = 9 and b² = 4.\n\nAnswer: Ellipse"
        },
        {
          id: 23,
          question: "A satellite dish has a parabolic cross-section. If the dish is 12 feet wide and 4 feet deep, where should the receiver be placed?",
          options: [
            "2.25 feet from the vertex",
            "3 feet from the vertex",
            "1.5 feet from the vertex",
            "4 feet from the vertex"
          ],
          correctAnswer: 0,
          solution: "Step 1: Place vertex at origin. The parabola opens upward.\n\nStep 2: The dish is 12 feet wide, so it extends from x = -6 to x = 6.\n\nStep 3: At x = 6, the depth is y = 4. Point (6, 4) is on the parabola.\n\nStep 4: Use x² = 4py and substitute (6, 4):\n36 = 4p(4)\n36 = 16p\np = 2.25\n\nStep 5: The receiver should be at the focus, which is p feet from the vertex.\n\nAnswer: 2.25 feet from the vertex"
        },
        {
          id: 24,
          question: "Complete the square to find the center: x² + y² - 8x + 6y + 9 = 0",
          options: [
            "(4, -3)",
            "(-4, 3)",
            "(8, -6)",
            "(4, 3)"
          ],
          correctAnswer: 0,
          solution: "Step 1: Group x and y terms:\n(x² - 8x) + (y² + 6y) = -9\n\nStep 2: Complete the square for x:\nx² - 8x + 16 = (x - 4)²\nAdd 16 to both sides.\n\nStep 3: Complete the square for y:\ny² + 6y + 9 = (y + 3)²\nAdd 9 to both sides.\n\nStep 4: Rewrite:\n(x - 4)² + (y + 3)² = -9 + 16 + 9 = 16\n\nStep 5: Center is at (4, -3).\n\nAnswer: (4, -3)"
        },
        {
          id: 25,
          question: "Identify the conic: 9x² - 4y² - 36 = 0",
          options: [
            "Hyperbola",
            "Ellipse",
            "Parabola",
            "Circle"
          ],
          correctAnswer: 0,
          solution: "Step 1: Rewrite: 9x² - 4y² = 36\n\nStep 2: Divide by 36: (x²/4) - (y²/9) = 1\n\nStep 3: One term is positive, one is negative (subtraction).\n\nStep 4: This is the standard form of a hyperbola.\n\nAnswer: Hyperbola"
        },
        {
          id: 26,
          question: "A cooling tower has a hyperbolic shape. At its narrowest point (20 feet from the ground), the diameter is 200 feet. At ground level and at 60 feet high, the diameter is 300 feet. If we model this with center at the narrowest point, find a² (in feet²).",
          options: [
            "10000",
            "22500",
            "2500",
            "5625"
          ],
          correctAnswer: 0,
          solution: "Step 1: Place center at the narrowest point (vertex of hyperbola).\n\nStep 2: At the center, radius = 100 feet, so a = 100.\n\nStep 3: The hyperbola is vertical: (y²/a²) - (x²/b²) = 1\n\nStep 4: At y = 40 (40 feet above/below center), radius = 150 feet.\n\nStep 5: Point (150, 40) is on the hyperbola, but we only need a².\n\nStep 6: a² = 100² = 10000\n\nAnswer: 10000"
        },
        {
          id: 27,
          question: "Which equation represents a parabola?",
          options: [
            "y = x² - 4x + 3",
            "x² + y² = 25",
            "x² - y² = 1",
            "4x² + 9y² = 36"
          ],
          correctAnswer: 0,
          solution: "Step 1: A parabola has only ONE squared term.\n\nStep 2: Check each option:\nA: y = x² - 4x + 3 (only x is squared) ✓\nB: x² + y² = 25 (both squared - circle)\nC: x² - y² = 1 (both squared - hyperbola)\nD: 4x² + 9y² = 36 (both squared - ellipse)\n\nAnswer: y = x² - 4x + 3"
        },
        {
          id: 28,
          question: "An elliptical pool has a major axis of 30 feet and minor axis of 20 feet. What is the distance between the foci?",
          options: [
            "10√5 feet",
            "10 feet",
            "5√5 feet",
            "20 feet"
          ],
          correctAnswer: 0,
          solution: "Step 1: Major axis = 2a = 30, so a = 15\n\nStep 2: Minor axis = 2b = 20, so b = 10\n\nStep 3: Calculate c using c² = a² - b²:\nc² = 225 - 100 = 125\nc = √125 = √(25 × 5) = 5√5\n\nStep 4: Distance between foci = 2c = 2(5√5) = 10√5 feet\n\nAnswer: 10√5 feet"
        },
        {
          id: 29,
          question: "Convert to standard form: x² - 4x - 8y + 20 = 0",
          options: [
            "(x - 2)² = 8(y - 2)",
            "(x - 2)² = 8y",
            "(x + 2)² = 8(y - 2)",
            "x² = 8(y - 2)"
          ],
          correctAnswer: 0,
          solution: "Step 1: Isolate terms with y:\nx² - 4x + 20 = 8y\n\nStep 2: Complete the square for x:\nx² - 4x + 4 = (x - 2)²\n\nStep 3: Add 4 to the right side:\n(x - 2)² + 20 = 8y + 4\n\nStep 4: Simplify:\n(x - 2)² = 8y + 4 - 20\n(x - 2)² = 8y - 16\n(x - 2)² = 8(y - 2)\n\nAnswer: (x - 2)² = 8(y - 2)"
        },
        {
          id: 30,
          question: "The orbit of a planet is an ellipse with the sun at one focus. If the closest distance to the sun is 90 million miles and the farthest is 110 million miles, find the length of the major axis.",
          options: [
            "200 million miles",
            "100 million miles",
            "20 million miles",
            "220 million miles"
          ],
          correctAnswer: 0,
          solution: "Step 1: Closest distance (perihelion) = a - c = 90\n\nStep 2: Farthest distance (aphelion) = a + c = 110\n\nStep 3: Add the two equations:\n(a - c) + (a + c) = 90 + 110\n2a = 200\na = 100\n\nStep 4: Length of major axis = 2a = 2(100) = 200 million miles\n\nAnswer: 200 million miles"
        }
      ]
    }
  ]
};